// extracted by mini-css-extract-plugin
export var modalContainer = "timer-module--modalContainer--A+4n6";
export var timer = "timer-module--timer--qDr1w";
export var controls = "timer-module--controls--grTYo";
export var timerControls = "timer-module--timerControls--9RKMH";
export var fadeIn = "timer-module--fadeIn--pZyZ3";